import type { ButtonProps } from '@sravni/react-design-system/lib/Button';

import type { MPLPreApprovalOffer } from 'commonTypes/api/scenarios/CreditSelectionScreenContent';

import { PreApprovalOfferControls } from '../ui/PreApprovalOfferControls';

export const getControlsByMplPreApprovalOffer = (
  offer: MPLPreApprovalOffer,
  controlButtonProps?: Pick<ButtonProps, 'size' | 'color' | 'type' | 'className' | 'onClick'>,
) => {
  if (offer.type === 'preApprovalsOffer') {
    return [
      <PreApprovalOfferControls
        key={0}
        offer={offer}
        buttonProps={controlButtonProps}
      />,
    ];
  }

  return [];
};
